import { STOModel } from "src/models/base/sto-model";
import { MyTeamTnADayDataWithBreaksDTO } from "src/models/tna/tna-day-data-with-breaks";
import { BaseApiService } from "../base/base-api.service";

export class MyTeamBreaksApiService extends BaseApiService<MyTeamTnADayDataWithBreaksDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/TnAOverviews",
      loadItemsPath: "/GetMyTeamTnABreaks",
    });
  }
}
